import { WebRecommendation } from '../../../../lib/recommendations';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { FourUKind } from './types';
import { FourUIcon } from './FourUIcon';

const colors = {
  pulse: {
    accent: 'rgba(var(--accent-glow-rgb),0.55)',
    accentSoft: 'rgba(var(--accent-glow-rgb),0.18)'
  },
  default: {
    accent: 'rgba(var(--accent-rgb),0.55)',
    accentSoft: 'rgba(var(--accent-rgb),0.18)'
  }
}

export function FourUCard({
  item,
  kind,
  onPick,
}: {
  item: WebRecommendation;
  kind: FourUKind;
  onPick: () => void;
}) {
  const { logPageClickBi } = useGenericBi();
  const accent = colors[kind === 'pulse' ? 'pulse' : 'default'].accentSoft
  const accentSoft = colors[kind === 'pulse' ? 'pulse' : 'default'].accentSoft
  const onCardPick = () => {
    logPageClickBi({
      page_name: 'chat_home',
      page_version: 'v3_chat_home',
      button_name: 'four_u_pick',
      answer: item.description || '',
      state: kind,
    });
    onPick();
  };
  return (
    <button
      type="button"
      onClick={onCardPick}
      style={styles.button}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = accent;
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.boxShadow = 'none';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = accentSoft;
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <FourUIcon slug={item.iconSlug} kind={kind} />
      <span style={styles.textContainer}>
        {item.name && (
          <span style={styles.nameContainer} >
            <span style={styles.name}>{item.name}</span>
          </span>
        )}
        <span
          style={styles.description}
        >
          {item.description}
        </span>
      </span>
    </button>
  );
}

const styles: Record<string, React.CSSProperties> = {
  button: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: '14px 16px',
    background:
      'linear-gradient(135deg, rgba(var(--accent-rgb),0.07) 0%, rgba(var(--hairline-rgb),0.02) 100%)',
    border: 'none',
    borderRadius: 'var(--sym-radius-container)',
    textAlign: 'start',
    cursor: 'pointer',
    color: 'inherit',
    overflow: 'hidden',
    transition: 'transform 180ms ease, border-color 180ms ease, box-shadow 220ms ease',
    boxShadow: 'none',
  },
  textContainer: {
    display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0, flex: 1
  },
  nameContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 14.5,
    fontWeight: 'var(--sym-weight-semibold)',
    color: 'rgba(var(--ink-rgb),0.95)',
    lineHeight: 1.25,
  },
  name: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 },
  description: {
    fontSize: 13.5,
    lineHeight: 1.45,
    color: 'rgba(var(--ink-rgb),0.65)',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  }
}
